import {
    Routes,
    Route,
    BrowserRouter as Router,
    Navigate,
} from 'react-router-dom';
import { ToastContainer} from 'react-toastify';
import { Routes as ROUTES } from './routes';

import './index.css';

function App() {
    return (
        <div className="app ">
            <Router>
                <Routes>
                    {ROUTES.map((route, index) => {
                        return (
                            <Route
                                path={route.url}
                                element={<route.component />}
                                key={index}
                            />
                        );
                    })}
                    {/* <Route path="/participants" element={<Navigate to="/dashboard" />} /> */}
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                </Routes>
            </Router>
            <ToastContainer />
        </div>
    );
}

export default App;
